import TOKEN_HTTP from './http-common-mv'

export default {
  getRefreshedToken (token) {
    return TOKEN_HTTP.post(`/services/verify_token.php`, {token})
  }
}
